import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  useGetPlaylistsQuery,
  useGetPlaylistByIdQuery,
  useGetSuggestedPlaylistsQuery,
} from '@backrs_ui/grow-ui/src/redux/priorities/priorities.api';
import { openPlaylistViewStep } from '@backrs_ui/grow-ui/src/redux/priorities/priorities.slice';

import { Box, Theme, SxProps } from '@mui/material';

import { PrioritiesHeader } from './atoms/PrioritiesHeader';
import { PlaylistSection } from './molecules/PlaylistSection';
import { SuggestedPlaylistsSection } from './molecules/SuggestedPlaylistsSection';

export const PrioritiesPageContainer = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  const { data: playlists, isLoading: isLoadingPlaylists } = useGetPlaylistsQuery(undefined);

  const { data: suggestedPlaylists, isLoading: isLoadingSuggestedPlaylists } =
    useGetSuggestedPlaylistsQuery(undefined);

  // Handle admin-playbook parameter
  const adminPlaybookId = searchParams.get('admin-playbook');
  const { data: adminPlaylist, isLoading: isLoadingAdminPlaylist } = useGetPlaylistByIdQuery(
    {
      id: Number(adminPlaybookId),
      isAdminRequest: !!adminPlaybookId,
    },
    {
      skip: !adminPlaybookId,
    },
  );

  useEffect(() => {
    if (adminPlaylist && !isLoadingAdminPlaylist) {
      // suggested playlists are mounted in the page shell
      dispatch(openPlaylistViewStep(adminPlaylist));
    }
  }, [dispatch, adminPlaylist, isLoadingAdminPlaylist]);

  if (isLoadingPlaylists || isLoadingSuggestedPlaylists) {
    return <FullScreenLoading />;
  }

  return (
    <Box sx={containerSx}>
      <PrioritiesHeader />

      {!isLoadingSuggestedPlaylists && suggestedPlaylists ? (
        <SuggestedPlaylistsSection playlists={suggestedPlaylists || []} />
      ) : null}

      <PlaylistSection playlists={playlists || []} />
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  containerType: 'inline-size',
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  flex: 1,
  alignItems: 'left',
  gap: backrs.spacing['spacing-2xl'],
  '@container (min-width: 600px)': {
    gap: backrs.spacing['spacing-4xl'],
  },
});
